require('./MethodOfPayment.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKTooltip } = require('commonsComponents/OKTooltip');
const mockHelper = require('../../utilities/mockDataHelper');
// @ constants
const {
    CARD_PAYMENT_METHOD_VARIABLE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE
} = require('constants/index');

class MethodOfPayment extends React.Component {
    constructor(props) {
        super(props);
        let initialState;
        if (this.props.values) {
            initialState = this.props.values;
        } else {
            initialState = {
                methodOfPayment: '',
                fixedFeeAmount: '',
                percentageAmount: '',
                inputFormat: ''
            };
        }
        this.state = initialState;
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.renderFeeAmount = this.renderFeeAmount.bind(this);
        this.renderAmountInput = this.renderAmountInput.bind(this);
        this.handleMethodOfPaymentChange = this.handleMethodOfPaymentChange.bind(this);

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if ( nextProps.values && nextProps.values.fixedFeeAmount !== this.state.fixedFeeAmount ) {
            this.handleMethodOfPaymentChange({
                label: '',
                value: nextProps.values.fixedFeeAmount
            });
            this.setState({
                fixedFeeAmount: nextProps.values.fixedFeeAmount
            })
        }
    }

    buildTooltipMethod(message, isDiamondOrPremiumCard) {
        const tooltipTranslation = isDiamondOrPremiumCard ? 'tooltipAmountsExampleDiamondPremium' : 'tooltipAmountsExample';
        const tooltipMethodText = formatText(`cardChangePaymentMethod-${tooltipTranslation}`);
        return (
            <div>
                {message}
                &nbsp;
                <OKTooltip
                    content={tooltipMethodText}
                    placement="top"
                    customClass="account-debit-detail__tooltip"
                    iconClass="icon method-of-payment__tooltip-icon"
                />
            </div>
        );
    }

    buildRadioButton(option, index) {
        const { nameContract } = this.props;
        const id = `methodOfPayment${index}`;
        const name = option.label.toLowerCase();
        const isChecked = this.state.methodOfPayment === option.value;
        const feeAmount = isChecked ? this.renderFeeAmount() : null;
        const isFixedOrVariable = this.state.methodOfPayment === CARD_PAYMENT_METHOD_FIXED || this.state.methodOfPayment === CARD_PAYMENT_METHOD_VARIABLE;
        const hasTooltip = ['visa-open', 'via-t', 'premium-pack', 'diamond-pack'].includes(nameContract);
        const isDiamondOrPremiumCard = ['premium-pack', 'diamond-pack'].includes(nameContract);
        const label = isChecked && isFixedOrVariable && hasTooltip ? this.buildTooltipMethod(option.label, isDiamondOrPremiumCard) : option.label;
        return (
            <div key={index}>
                <RadioButton
                    id={id}
                    name={name}
                    label={label}
                    value={option.value}
                    className="block-step__radio"
                    onChange={this.handleRadioButtonChange}
                    isChecked={isChecked}
                />
                {feeAmount}
            </div>
        );
    }

    handleMethodOfPaymentChange(event) {
        let state = Object.assign({}, this.state);
        if (event.label.includes('%')) {
            state.percentageAmount = event.value;
            state.inputFormat = '%';
        } else {
            state.fixedFeeAmount = event.value;
            state.inputFormat = '€';
        }
        this.props.dataReceiver(state);
        this.setState(state);
    }

    handleOnChange(event) {
        let state = Object.assign({}, this.state);
        state.methodOfPayment = event.value;
        this.props.dataReceiver(state);
        this.setState(state);
    }

    handleRadioButtonChange(event) {
        let inputFormat;
        if (event === mockHelper.methodOfPaymentValues.FIXED_FEE) {
            inputFormat = '€';
        } else if (event === mockHelper.methodOfPaymentValues.PERCENTAGE) {
            inputFormat = '%';
        }
        let state = Object.assign({}, this.state, {
            methodOfPayment: event,
            fixedFeeAmount: this.props.fixedFeeDefaultOption || '',
            percentageAmount: this.props.percentageDefaultOption || '',
            inputFormat: inputFormat || ''
        });
        this.props.dataReceiver(state);
        this.setState(state);
    }

    renderAmountInput(minPercentage) {
        const { methodOfPayment } = this.state;
        const { fixedOptions, percentageOptions, errorMessage, errorState } = this.props;
        const options = methodOfPayment === mockHelper.methodOfPaymentValues.FIXED_FEE ? fixedOptions : percentageOptions;
        const value = methodOfPayment === mockHelper.methodOfPaymentValues.FIXED_FEE ? this.state.fixedFeeAmount : this.state.percentageAmount;
        const label = methodOfPayment === mockHelper.methodOfPaymentValues.FIXED_FEE ? formatText('contractsView-feeAmount') : null;
        const showError = methodOfPayment && value === '' && errorState;
        let minPercentageSection;

        if (minPercentage) {
            minPercentageSection = (
                <div className="method-of-payment__min-percentage">
                    <FormattedText
                        value="contractsView-diamondPremiumViaTVisaMinPercentage"
                        injectedStrings={[minPercentage]}
                    />
                </div>
            );
        }

        return (
            <div className="method-of-payment__fee-input">
                <span>
                    <OKSelect
                        label={label}
                        searchable={true}
                        options={options}
                        onChange={this.handleMethodOfPaymentChange}
                        value={value}
                        errorState={showError}
                        errorMessage={errorMessage}
                    />
                </span>
                {minPercentageSection}
            </div>
        );
    }

    renderFeeAmount() {
        switch (this.state.methodOfPayment) {
            case mockHelper.methodOfPaymentValues.FIXED_FEE:
                return this.renderAmountInput();
            case mockHelper.methodOfPaymentValues.PERCENTAGE:
                return this.renderAmountInput(CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE);
            default:
                return null;
        }
    }

    render() {
        const { immCardDetails, errorMessage, title, extraInfo, errorState } = this.props;
        const methodOfPaymentObject = immCardDetails.find(x => x.get('id') === 'methodOfPayment');
        const methodOfPayment = methodOfPaymentObject ? methodOfPaymentObject.get('value') : null;
        const showError = !methodOfPayment &&  errorState;
        let content;
        let toolTip;

        if (this.props.format === 'select') {
            content = (
                <OKSelect
                    placeholder="Selecciona"
                    searchable={true}
                    options={mockHelper.mockMethodOfPayment()}
                    onChange={this.handleOnChange}
                    value={methodOfPayment}
                    errorState={showError}
                    errorMessage={errorMessage}
                />
            );
        } else {
            const radioButtons = mockHelper.mockMethodOfPayment().map((option, index) => {
                return this.buildRadioButton(option, index);
            });

            content = (
                <RadioButtonGroup
                    name="selectMethodOfPayment"
                    idPrefix="selectMethodOfPayment"
                    selectedValue={methodOfPayment}
                    errorState={showError}
                    errorMessage={errorMessage}
                >
                    {radioButtons}
                </RadioButtonGroup>
            );
        }

        if (extraInfo) {
            toolTip = (
                <OKTooltip
                    content={extraInfo}
                    placement="top"
                    customClass="account-debit-detail__tooltip"
                    iconClass="icon method-of-payment__tooltip-icon"
                    offset={[0, -10]}
                />
            );
        }

        return (
            <article className="method-of-payment">
                <header className="method-of-payment__header">
                    <FormattedText value={title} className="method-of-payment__header-label"/>
                    {toolTip}
                </header>
                <section className="method-of-payment__content">
                    {content}
                </section>
            </article>
        );
    }
}

MethodOfPayment.defaultProps = {
    component_id: 'methodOfPayment',
    format: 'radio',
    nameContract: '',
    title: 'contractSummary-methodOfPayment'
};

MethodOfPayment.propTypes = {
    dataReceiver: PropTypes.func,
    errorMessage: PropTypes.string,
    errorState: PropTypes.boolean,
    extraInfo: PropTypes.object,
    fixedFeeDefaultOption: PropTypes.number,
    fixedOptions: PropTypes.array,
    format: PropTypes.oneOf(['radio', 'select']),
    immCardDetails: PropTypes.any,
    nameContract: PropTypes.string,
    percentageDefaultOption: PropTypes.number,
    percentageOptions: PropTypes.array,
    title: PropTypes.string,
    values: PropTypes.object
};

module.exports = MethodOfPayment;
